export default __webpack_public_path__ + "static/media/violet.b5985acd.png";